/* Baumfink: Mengenregel fuer Wurzelware im Warenkorb durchsetzen.
Erlaubt sind min und danach Schritte von step (aktuell 10, 15, 20, 25 ...).
min/step kommen aus dem Mengenfeld (snippets/quantity-selector.liquid).
Die Theme-Logik in empire.js ignoriert beide Attribute, deshalb greift dieses Skript vorher ein. */
(function () {
var MSG = 'Wurzelware verkaufen wir ab 10 Stück pro Sorte und Größe, danach in 5er-Schritten (10, 15, 20 …). Bitte passe die Menge an, um zur Kasse zu gehen.';
var ITEM = '[data-cartitem-id]';
var INPUT = '[data-quantity-input]';
var lastBad = null;

function rule(input) {
var min = parseInt(input.getAttribute('min'), 10);
var step = parseInt(input.getAttribute('step'), 10);
return { min: isNaN(min) || min < 1 ? 1 : min, step: isNaN(step) || step < 1 ? 1 : step };
}

function restricted(input) {
var r = rule(input);
return r.min > 1 || r.step > 1;
}

function isCartInput(el) {
return !!(el && el.matches && el.matches(INPUT) && el.closest(ITEM));
}

/* 0 bedeutet entfernen und ist immer erlaubt */
function isValid(input) {
var q = input.valueAsNumber;
var r = rule(input);
if (!q) return true;
return q >= r.min && (q - r.min) % r.step === 0;
}

/* naechste erlaubte Menge, die mindestens q ist */
function roundUp(input, q) {
var r = rule(input);
if (q <= r.min) return r.min;
return r.min + Math.ceil((q - r.min) / r.step) * r.step;
}

function invalidInputs() {
return Array.prototype.filter.call(document.querySelectorAll(ITEM + ' ' + INPUT), function (i) {
return !isValid(i);
});
}

/* Plus/Minus: in erlaubten Schritten zaehlen statt in 1er-Schritten */
document.addEventListener('click', function (e) {
var btn = e.target.closest && e.target.closest('[data-quantity-minus], [data-quantity-plus]');
if (!btn) return;
var field = btn.closest('[data-quantity-selector]');
var input = field && field.querySelector(INPUT);
if (!isCartInput(input) || !restricted(input)) return;
e.preventDefault();
e.stopImmediatePropagation();
var r = rule(input);
var q = input.valueAsNumber || r.min;
var next = btn.matches('[data-quantity-plus]') ? roundUp(input, q + 1) : (q <= r.min ? r.min : roundUp(input, q - r.step));
if (next !== input.valueAsNumber) {
input.value = next;
input.dispatchEvent(new Event('change', { bubbles: true }));
}
}, true);

/* Getippte Werte erst beim Verlassen des Feldes uebernehmen (sonst wird z. B. "1" auf dem Weg zu "15" gespeichert) */
document.addEventListener('keyup', function (e) {
if (isCartInput(e.target) && restricted(e.target)) e.stopImmediatePropagation();
}, true);

/* Unpassende getippte Werte auf die naechste erlaubte Menge anheben (z. B. 3 -> 10, 12 -> 15) */
document.addEventListener('change', function (e) {
var input = e.target;
if (!isCartInput(input) || !restricted(input) || isValid(input)) return;
input.value = roundUp(input, input.valueAsNumber);
}, true);

/* Kasse sperren, solange eine Position nicht der Regel entspricht */
function update() {
var bad = invalidInputs().length > 0;
if (bad === lastBad || (lastBad === null && !bad)) { lastBad = bad; return; }
lastBad = bad;
document.querySelectorAll('[name="checkout"]').forEach(function (b) {
b.disabled = bad;
b.style.opacity = bad ? '0.5' : '';
b.style.cursor = bad ? 'not-allowed' : '';
var note = b.previousElementSibling;
var hasNote = note && note.classList.contains('bf-min-qty-note');
if (bad && !hasNote) {
note = document.createElement('p');
note.className = 'bf-min-qty-note';
note.setAttribute('role', 'alert');
note.textContent = MSG;
note.style.cssText = 'color:#b00020;font-weight:600;margin:0 0 12px;';
b.parentNode.insertBefore(note, b);
} else if (!bad && hasNote) {
note.remove();
}
});
document.querySelectorAll('.additional-checkout-buttons, shopify-accelerated-checkout-cart').forEach(function (el) {
el.style.display = bad ? 'none' : '';
});
}

document.addEventListener('submit', function (e) {
var s = e.submitter;
if (s && s.name === 'checkout' && invalidInputs().length) {
e.preventDefault();
lastBad = null;
update();
}
}, true);

var timer;
new MutationObserver(function () {
clearTimeout(timer);
timer = setTimeout(update, 100);
}).observe(document.body, { childList: true, subtree: true });
update();
})();
